import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { UserSelectors } from '../../../redux/reducers/userSlice';
import RadioButton from '../../../components/RadioButton';
import IndividualSettings from '../IndividualSettings';
import EntitySettings from '../EntitySettings';

import styles from './OrganizationWrap.module.scss';
import { Navigate, Route, Routes } from 'react-router-dom';
import { RoutesList } from '../../../App';

const OrganizationWrap = () => {
  const owner = useSelector(UserSelectors.getOwnerInfo);

  const RadioButtonList = ['Физическое лицо', 'Юридическое лицо'];
  const [activeRadioBtn, setActiveRadioBtn] = useState<number>(0);

  return (
    <>
      <h3 className={styles.title}>Данные об организации</h3>
      <div className={styles.btnContainer}>
        <RadioButton
          activeTab={activeRadioBtn}
          btnsList={RadioButtonList}
          onClick={setActiveRadioBtn}
          size="big"
        />
      </div>
      <div className={styles.contentContainer}>
        {/* <Routes>
        <Route index element={<IndividualSettings id={owner?.individual_id}/>} 
          
        />
        <Route
          path={"/entity"}
          element={<EntitySettings id={owner?.entity_id}/>}
        />        
        <Route
          path={RoutesList.any.path}
          element={<Navigate to={RoutesList.notFound.fullPath} replace />}
        />
      </Routes> */}

        {activeRadioBtn === 1 ? (
          <EntitySettings id={owner?.entity_id} />
        ) : (
          <IndividualSettings id={owner?.individual_id} />
        )}
      </div>
    </>
  );
};

export default OrganizationWrap;
